import { RefObject, useContext, useEffect, useState } from "react";
import useScrollTrigger from "@mui/material/useScrollTrigger";
import { Fab, Fade } from "@mui/material";
import Box from "@mui/material/Box";
import { KeyboardArrowUp } from "@mui/icons-material";
import { MainLayoutContext } from "layout/MainLayout/context";

interface ScrollTopButtonProps {
  scrollIntoRef?: RefObject<HTMLDivElement>;
  threshold?: number;
}

const ScrollTopButton = ({ scrollIntoRef, threshold }: ScrollTopButtonProps) => {
  const { mainBoxRef } = useContext(MainLayoutContext);
  const [target, setTarget] = useState<HTMLDivElement | undefined>(
    scrollIntoRef?.current || mainBoxRef?.current || undefined
  );
  const trigger = useScrollTrigger({
    target,
    disableHysteresis: true,
    threshold: threshold || 100,
  });

  const handleClick = () => {
    target?.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    const scrollIntoRefCurrent = scrollIntoRef?.current;
    if (scrollIntoRefCurrent) setTarget(scrollIntoRefCurrent);
  }, []);

  return (
    <Fade in={trigger}>
      <Box
        onClick={handleClick}
        role='presentation'
        sx={{ position: "fixed", zIndex: 9, bottom: 24, right: 32 }}>
        <Fab
          size='small'
          aria-label='scroll back to top'
          sx={{ backgroundColor: "orange.light" }}>
          <KeyboardArrowUp />
        </Fab>
      </Box>
    </Fade>
  );
};

export default ScrollTopButton;
